import { Command } from "@ckeditor/ckeditor5-core";

export default class ShowCharactersCommand extends Command {
  execute(value) {
    const editor = this.editor;

    editor.fire("cde:setShowCharacters", value);
  }

  refresh() {
    this.isEnabled = true;
    this.value = !!this.editor.showCharacters;
  }
}
